import { createSlice } from '@reduxjs/toolkit';
import { addNewVehicle, editVehicle, editVehicleImage, getAllVehicles, getVehicleById } from './vehicleService';

const initialState = {
  allVehicles: {
    isVehiclesLoading: null,
    isVehiclesSuccess: null,
    vehiclesMessage: null,
    pageCount: 0,
    vehicles: [],
  },
  newVehicle: {
    isVehicleCreating: null,
    isVehicleCreated: null,
    vehicleCreationMsg: null,
  },

  editedVehicle: {
    isEditingVehicle: null,
    isVehicleEdited: null,
    vehicleEditedMsg: null
  },

  editedVehicleImage: {
    isEditingVehicleImage: null,
    isVehicleImageEdited: null,
    vehicleImageEditedMsg: null
  },

  vehicle: {
    isVehicleLoading: null,
    isVehicleSuccess: null,
    vehicleMessage: null,
    vehicle: null,
  },
};

const vehiclesSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllVehicles.pending, (state) => {
        state.allVehicles = {
          ...initialState.allVehicles, // Reset to initial state
          isVehiclesLoading: true,
          vehiclesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllVehicles.rejected, (state, action) => {
        state.allVehicles = {
          ...initialState.allVehicles,
          isVehiclesLoading: false,
          isVehiclesSuccess: false,
          vehiclesMessage: action.payload || 'Error occurred while fetching vehicles',
        };
      })

      // FULFILLED
      .addCase(getAllVehicles.fulfilled, (state, action) => {
        state.allVehicles = {
          ...initialState.allVehicles,
          isVehiclesLoading: false,
          isVehiclesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          vehicles: action.payload.data || [],
        };
      });

    //Vehicle creating
    builder
      .addCase(addNewVehicle.pending, (state) => {
        state.newVehicle = {
          ...initialState.newVehicle, // Reset to initial state
          isVehicleCreating: true,
          vehicleCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewVehicle.rejected, (state, action) => {
        state.newVehicle = {
          ...initialState.newVehicle,
          isVehicleCreating: false,
          isVehicleCreated: false,
          vehicleCreationMsg: action.payload || 'Error occurred while creating the vehicle.',
        };
      })

      // FULFILLED
      .addCase(addNewVehicle.fulfilled, (state, action) => {
        state.newVehicle = {
          ...initialState.newVehicle,
          isVehicleCreating: false,
          isVehicleCreated: true,
          vehicleCreationMsg: action.payload || 'Successfully created the vehicle.',
        };
      });

    //Vehicle editing
    builder
      .addCase(editVehicle.pending, (state) => {
        state.editedVehicle = {
          ...initialState.editedVehicle, // Reset to initial state
          isEditingVehicle: true,
          vehicleEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editVehicle.rejected, (state, action) => {
        state.editedVehicle = {
          ...initialState.editedVehicle, // Reset to initial state
          isEditingVehicle: false,
          isVehicleEdited: false,
          vehicleEditedMsg: action.payload || 'Error occurred while editing the vehicle.',
        };
      })

      // FULFILLED
      .addCase(editVehicle.fulfilled, (state, action) => {
        state.editedVehicle = {
          ...initialState.editedVehicle, // Reset to initial state
          isEditingVehicle: false,
          isVehicleEdited: true,
          vehicleEditedMsg: action.payload || 'Successfully edited the vehicle.',
        };
      });

    //Vehicle image editing
    builder
      .addCase(editVehicleImage.pending, (state) => {
        state.editedVehicleImage = {
          ...initialState.editedVehicleImage, // Reset to initial state
          isEditingVehicleImage: true,
          vehicleImageEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editVehicleImage.rejected, (state, action) => {
        state.editedVehicleImage = {
          ...initialState.editedVehicleImage, // Reset to initial state
          isEditingVehicleImage: false,
          isVehicleImageEdited: false,
          vehicleImageEditedMsg: action.payload || 'Error occurred while editing the vehicle image.',
        };
      })

      // FULFILLED
      .addCase(editVehicleImage.fulfilled, (state, action) => {
        state.editedVehicleImage = {
          ...initialState.editedVehicleImage, // Reset to initial state
          isEditingVehicleImage: false,
          isVehicleImageEdited: false,
          vehicleImageEditedMsg: action.payload || 'Successfully edited the vehicle image.',
        };
      });

      //Vehicle details
      builder
      .addCase(getVehicleById.pending, (state) => {
        state.vehicle = {
          ...initialState.vehicle, // Reset to initial state
          isVehicleLoading: true,
          vehicleMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getVehicleById.rejected, (state, action) => {
        state.vehicle = {
          ...initialState.vehicle,
          isVehicleLoading: false,
          isVehicleSuccess: false,
          vehicleMessage: action.payload || 'Error occurred while fetching vehicle',
        };
      })

      // FULFILLED
      .addCase(getVehicleById.fulfilled, (state, action) => {
        state.vehicle = {
          ...initialState.vehicle,
          isVehicleLoading: false,
          isVehicleSuccess: true,
          vehicle: action.payload,
        };
      });
  },
});

export default vehiclesSlice.reducer;
